import { Action, createAction, props } from '@ngrx/store';

import { User } from '@shared/models';
import { Pagination } from '@shared/pagination';

export enum UsersActionTypes {
  Load = '[Users] Load',
  LoadSuccess = '[Users] Load success',

  LoggedIn = '[Users] Logged In',
  LoggedInSuccess = '[Users] Logged In success',

  Get = '[Users] Get',
  GetSuccess = '[Users] Get success',

  List = '[Users] Get List',
  ListSuccess = '[Users] Get List Success',
  ListFailure = '[Users] Get List Failure',

  Create = '[Users] Create',
  CreateSuccess = '[Users] Create success',
  CreateFailure = '[Users] Create failure',

  Update = '[Users] Update',
  UpdateSuccess = '[Users] Update success',
  UpdateFailure = '[Users] Update failure',

  UpdateLoggedInUserSuccess = '[Users] Update logged in user success',

  Delete = '[Users] Delete',
  DeleteSuccess = '[Users] Delete Success',

  ChangePassword = '[Users] Change Password',
  ChangePasswordSuccess = '[Users] Change Password Success',
  ChangePasswordFailure = '[Users] Change Password Failure',
}

// LOAD
export class UsersLoad implements Action {
  readonly type = UsersActionTypes.Load;

  constructor(public payload: any) {}
}

export class UsersLoadSuccess implements Action {
  readonly type = UsersActionTypes.LoadSuccess;

  constructor(public payload: Pagination<User>) {}
}

// LOGGED-IN
export class UsersLoggedIn implements Action {
  readonly type = UsersActionTypes.LoggedIn;
}

export class UsersLoggedInSuccess implements Action {
  readonly type = UsersActionTypes.LoggedInSuccess;

  constructor(public payload: User) {}
}

// GET
export class UsersGet implements Action {
  readonly type = UsersActionTypes.Get;

  constructor(public payload?: { id: number; locked?: boolean }) {}
}

export class UsersGetSuccess implements Action {
  readonly type = UsersActionTypes.GetSuccess;

  constructor(public payload: User) {}
}

// LIST
export class UsersList implements Action {
  readonly type = UsersActionTypes.List;

  constructor(public payload: { userIds: number[] }) {}
}

export class UsersListSuccess implements Action {
  readonly type = UsersActionTypes.ListSuccess;

  constructor(public payload: { users: User[] }) {}
}

export class UsersListFailure implements Action {
  readonly type = UsersActionTypes.ListFailure;

  constructor(public payload: { error: any }) {}
}

// CREATE
export class UsersCreate implements Action {
  readonly type = UsersActionTypes.Create;

  constructor(public payload: User) {}
}

export class UsersCreateSuccess implements Action {
  readonly type = UsersActionTypes.CreateSuccess;

  constructor(public payload: User) {}
}

export class UsersCreateFailure implements Action {
  readonly type = UsersActionTypes.CreateFailure;

  constructor(public payload: any) {}
}

// UPDATE
export class UsersUpdate implements Action {
  readonly type = UsersActionTypes.Update;

  constructor(
    public payload: {
      id: number;
      body: Partial<User>;
    },
  ) {}
}

export const selfUpdateProfile = createAction(
  '[Users] Self Update Profile',
  props<{ body: User }>(),
);

export const selfUpdateProfileSuccess = createAction(
  '[Users] Self Update Profile Success',
  props<{ payload: User }>(),
);

export const selfUpdateProfileFail = createAction(
  '[Users] Self Update Profile Fail',
  props<{ error: any }>(),
);

export class UsersUpdateSuccess implements Action {
  readonly type = UsersActionTypes.UpdateSuccess;

  constructor(public payload: User) {}
}

export class UsersUpdateFailure implements Action {
  readonly type = UsersActionTypes.UpdateFailure;

  constructor(public payload: { error: any }) {}
}

export class UsersUpdateLoggedInUserSuccess implements Action {
  readonly type = UsersActionTypes.UpdateLoggedInUserSuccess;

  constructor(public payload: User) {}
}

// DELETE
export class UsersDelete implements Action {
  readonly type = UsersActionTypes.Delete;

  constructor(public payload: number) {}
}

export class UsersDeleteSuccess implements Action {
  readonly type = UsersActionTypes.DeleteSuccess;

  constructor(public payload: User) {}
}

// CHANGE PASSWORD
export class UsersChangePassword implements Action {
  readonly type = UsersActionTypes.ChangePassword;

  constructor(public payload?: any) {}
}

export class UsersChangePasswordSuccess implements Action {
  readonly type = UsersActionTypes.ChangePasswordSuccess;

  constructor(public payload?: any) {}
}

export class UsersChangePasswordFailure implements Action {
  readonly type = UsersActionTypes.ChangePasswordFailure;

  constructor(public payload?: any) {}
}

export type UserActionsUnion =
  | UsersLoad
  | UsersLoadSuccess
  | UsersGet
  | UsersGetSuccess
  | UsersList
  | UsersListSuccess
  | UsersListFailure
  | UsersCreate
  | UsersCreateSuccess
  | UsersCreateFailure
  | UsersUpdate
  | UsersUpdateSuccess
  | UsersUpdateFailure
  | UsersUpdateLoggedInUserSuccess
  | UsersDelete
  | UsersDeleteSuccess
  | UsersChangePassword
  | UsersChangePasswordSuccess
  | UsersChangePasswordFailure
  | UsersLoggedInSuccess;
